import React from 'react';

const NotFound = () => <div className="404-error">Nao achamos o que Procura</div>;

export default NotFound;